var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pt-10 px-6 pb-20 body"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "password",
      "label": "Password Saat Ini",
      "error": _vm.errors['currentPassword'],
      "placeholder": "Masukan password saat ini"
    },
    model: {
      value: _vm.payload.currentPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "currentPassword", $$v);
      },
      expression: "payload.currentPassword"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "password",
      "label": "Password Baru",
      "error": _vm.errors['newPassword'],
      "placeholder": "Silahkan masukan password baru kamu"
    },
    model: {
      value: _vm.payload.newPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "newPassword", $$v);
      },
      expression: "payload.newPassword"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "password",
      "label": "Konfirmasi Password Baru",
      "error": _vm.errors['newPasswordConfirmation'],
      "placeholder": "Silahkan masukan password baru kamu"
    },
    model: {
      value: _vm.payload.newPasswordConfirmation,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "newPasswordConfirmation", $$v);
      },
      expression: "payload.newPasswordConfirmation"
    }
  })], 1), _c('div', {
    staticClass: "px-6 pb-6 bg-white fixed bottom-0 left-0 z-1 w-full"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Update",
      "size": "full"
    },
    on: {
      "action": function action($event) {
        return _vm.update();
      }
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }